import React, { useContext, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { CommonContext, HomeContext } from '../../context';

const ImageModal = () => {
    const { indexData } = useContext(CommonContext);
    const { modal, handleCloseModal, handleAddModals } = useContext(HomeContext);


    const handleImageClick = () => {
        if (indexData?.popup?.link) {
            window.open(indexData?.popup?.link, '_blank');
        }
    };


    useEffect(() => {
        if (!modal) {
            const timer = setTimeout(() => {
                if (indexData?.popup?.image) {
                    handleAddModals();
                }
            }, indexData?.popup?.delay || 5000);

            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <Modal isOpen={modal} toggle={handleCloseModal} className='image-modal' size="md">
            <ModalHeader toggle={handleCloseModal} />
            <ModalBody>
                <img
                    src={`${process.env.REACT_APP_BASE_URL}/img/popups/${indexData?.popup?.image}`}
                    alt="Modal"
                    style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                    onClick={handleImageClick}
                />
            </ModalBody>
        </Modal>
    );
};

export default ImageModal;
